

































import { Getter } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Destinations extends Vue {
    @Getter('$auth/isAdmin') isAdmin: boolean | undefined;

    async mounted() {
      await this.$store.dispatch('$destinations/reload');
    }

    addDestination() {
      this.$router.push({ name: 'destination', params: { did: 'new' }});
    }
}
